export const WA_NUMBER_DISPLAY = "0551799245";
export const WA_NUMBER_INTL = "966551799245";

export const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER_INTL}?text=${encodeURIComponent(msg)}`;

export const CALL_LINK = `tel:+${WA_NUMBER_INTL}`;

export const EMAIL = "Owner@Shiyadn.com";
export const EMAIL_LINK = `mailto:${EMAIL}`;

export const MESSAGES = {
  general: "السلام عليكم، أرغب بالتواصل مع شيادن الأصول العقارية.",
  seeker:
    "السلام عليكم، أبحث عن عقار وأرغب بمساعدتكم في الوصول إلى الخيار المناسب.\nالمدينة:\nالحي:\nنوع العقار:\nالميزانية:",
  owner:
    "السلام عليكم، لدي عقار وأرغب في معرفة إمكانية تسويقه/تأجيره عن طريق شيادن الأصول العقارية.",
  property: (ref) =>
    `السلام عليكم، أرغب بالاستفسار عن العقار رقم ${ref} المعروض في موقع شيادن الأصول العقارية.`,
};

export const scrollToId = (id) => {
  if (window.lenis) {
    window.lenis.scrollTo(id, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const NAV_LINKS = [
  { id: "#about", label: "من نحن" },
  { id: "#services", label: "خدماتنا" },
  { id: "#properties", label: "عقارات مختارة" },
  { id: "#why", label: "لماذا شيادن" },
  { id: "#contact", label: "تواصل معنا" },
];

export const PROPERTIES = [
  {
    ref: "SH-001",
    type: "فيلا حديثة",
    city: "الرياض",
    district: "حي الياسمين",
    area: "450",
    rooms: "5",
    price: "3,200,000",
    image:
      "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4OTk5MDc0MXww&ixlib=rb-4.1.0&q=85",
    alt: "فيلا حديثة مع مسبح في حي الياسمين بالرياض",
  },
  {
    ref: "SH-002",
    type: "فيلا فاخرة",
    city: "جدة",
    district: "حي الشاطئ",
    area: "380",
    rooms: "4",
    price: "2,750,000",
    image:
      "https://images.pexels.com/photos/16573669/pexels-photo-16573669.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "واجهة فيلا فاخرة مضاءة وقت الغروب في حي الشاطئ بجدة",
  },
  {
    ref: "SH-003",
    type: "شقة عصرية",
    city: "الرياض",
    district: "حي الملقا",
    area: "180",
    rooms: "3",
    price: "1,150,000",
    image:
      "https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk5OTA3NDF8MA&ixlib=rb-4.1.0&q=85",
    alt: "صالة شقة عصرية بنوافذ واسعة في حي الملقا بالرياض",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBleHRlcmlvciUyMGR1c2t8ZW58MHx8fHwxNzg5OTkwNzQxfDA&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.pexels.com/photos/13752348/pexels-photo-13752348.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
